// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const stock_get = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'products', data)
  commit('setStocks', res.data)
  commit('stockLoading', false)
}

export const stock_detail = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'products/'+data.id)
  commit('setStock', res.data)
  commit('stockLoading', false)
}

export const stock_list = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'products', data)
  commit('setStocks', res.data)
  commit('stockLoading', false)
}

export const stock_state = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('put', `products/${data.id}/active`, data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const addStock = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('post', 'products', data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const editStock = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('put', `products/${data.id}`, data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const fetchMovements = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'products/stock-movements', data)
  commit('setMovements', res.data)
  commit('stockLoading', false)
}

export const stockMovement = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('post', 'products/stock-movements', data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const barcode_stock = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('post', 'products/stock-movements', data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const movement_type_list = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', '/stock-movement-types')
  commit('setMovementTypes', res.data)
  commit('stockLoading', false)
}

export const stock_delete = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('delete', `products/${data.id}`)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const stockmovements_delete = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('delete', `products/stock-movements/${data.id}`)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const stockmovements_edit = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('put', `products/stock-movements/${data.id}`, data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const stockmovements_get = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'products/stock-movements')
  commit('setMovements', res.data)
  commit('stockLoading', false)
}
export const stockmovements_detail = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'products/stock-movements/'+data)
  commit('stockMovementDetail', res.data)
  commit('stockLoading', false)
}

export const faultsupports_get = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', 'fault-supports', data)
  commit('setFaultSupports', res.data)
  // commit('setStockPageInfo', res.data.list_info)
  commit('stockLoading', false)
}

export const fetchFaultSupport = async ({ commit }, id) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', `fault-supports/${id}`)
  commit('setFaultSupport', res.data)
  commit('stockLoading', false)
}

export const fault_movements_type_list = async ({ commit }) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', `fault-supports/fault-supports-movement/status`)
  commit('setFaultStatuses', res.data)
  commit('stockLoading', false)
}

export const addFaultSupport = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('post', 'fault-supports',  data)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const faultsupports_image = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('post', `fault-supports/${data.id}/images`,  data.formData)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const fetchFaultSupportImages = async ({ commit }, id) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', `fault-supports/${id}/images`)
  commit('setFaultSupportImages', res.data)
  commit('stockLoading', false)
}

export const faultsupports_movement = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('post', `fault-supports/${data.id}/movements`,  data)
  console.log(res)
  commit('setStockStatus', res.data ? res.data : res)
  commit('stockLoading', false)
}

export const faultsupports_close = async ({ commit }, data) => {
  commit('stockLoading', true)
  let res;
  console.log(data)
  res = await sendReq('post', `fault-supports/${data.id}/close`, data.formData)
  commit('setStockStatus', res.data)
  commit('stockLoading', false)
}

export const fetchPieces = async ({ commit }) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', `fault-support-pieces`)
  commit('setPieces', res.data)
  commit('stockLoading', false)
}

export const stock_pieces_list = async ({ commit }) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', `fault-support-pieces`)
  commit('setPieces', res.data)
  commit('stockLoading', false)
}

export const fetchFaultSupportPieces = async ({ commit }, id) => {
  commit('stockLoading', true)
  let res;
  res = await sendReq('get', `/fault-supports/${id}/pieces`)
  commit('setFaultSupportPieces', res.data)
  commit('stockLoading', false)
}

export const getStockFileUrl = async (_, path) => {
  const res = await sendReq('get', path, { responseType: 'blob' })
  return URL.createObjectURL(res.data)
}

export const fault_result_list = async ({ commit }) => {
  commit('stockLoading', true)
  const res = await sendReq('get', '/fault-support-result')
  commit('setFaultSupportResults', res.data)
  commit('stockLoading', false)
}

export const fetchFaultTracking = async ({ commit }, id) => {
  commit('stockLoading', true)
  const res = await sendReq('get', `/fault-support-query/${id}`)
  commit('setFaultTracking', res) 
  commit('stockLoading', false)
}

export const untrack_remove = async ({ commit }, data) => {
  commit('stockLoading', true)
  const res = await sendReq('post', `/products/${data.serial_no}/take-out-untrack`, data)
  commit('setStockStatus', res.data) 
  commit('stockLoading', false)
}

export const movement_remove = async ({ commit }, data) => {
  commit('stockLoading', true)
  const res = await sendReq('delete', `/products/${data.serial_no}/take-out-untrack`)
  commit('setStockStatus', res.data) 
  commit('stockLoading', false)
}

export const untrack_info_get = async ({ commit }, data) => {
  commit('stockLoading', true)
  const res = await sendReq('get', `/products/${data.serial_number}/query-untrack`)
  commit('untrackInfo', res.data) 
  commit('stockLoading', false)
}




// WEBPACK FOOTER //
// ./src/store/modules/Stock/Actions.js